import axios from 'axios'
import { formatoFecha } from 'components/Admin/Inicio-Admin/Dashboard_Individual_Admin';
import PlanificacionVacaciones, { ESTADO_APROBACION_PARCIAL, ESTADO_ENVIADO_TALENTO_HUMANO, function_parse_calendario } from 'components/UsuarioGeneral/Vacaciones/Planificacion Vacaciones/PlanificacionVacaciones';
import Cargando from 'components/Varios/Cargando';
import React, { Component, useEffect, useState } from 'react'
import { Container } from 'react-bootstrap';
import { Tooltip, Table, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardBody, CardTitle, CardFooter, Row, Col } from "reactstrap"
import { authenticationService } from 'services/authentication.service';
//URL
import configData from "../../../config.json";
import { handle_error } from './helper_function';
import { Datos_Planificacion_Aprobada } from './PlanificacionVacaciones';

type Props_ModalDirectivo = {
    show: boolean
    toogle: () => void
    idpersona: number
    onClose: () => void
    propagar_Aprobado: (planificacion_propaga: Datos_Planificacion_Aprobada) => void,
    tipo_aprobador: string,
    estado_persona_planificaciones: string,
    mostrar_boton_enviar: boolean,
    isDelegado: boolean
}

type State_ModalDirectivo = {
    cards_calendario: Array<HTMLElement>,
    idpersona: number,
}

export type Planificacion_Vacaciones = {
    fechainicio: Date,
    fechafin: Date,
    dias_solicitados: number,
    estado?: string,
    directivounidad?: string
    idplanificacion: number,
    observacion?: string
    iddirectivounidad: number
}

type Respuesta_Planificacion_Usuario = {
    listado_planificacion: Array<Planificacion_Vacaciones>
    fecha_consulta: Date,
    nombre_persona: string
}
type Calendario_Vacaciones_Modal = {
    Mes: string,
    Orden: number,
    Anio: string,
    Color: string,
    Rows?: Array<Planificacion_Vacaciones>,
    Estado?: string,
    Persona_Regula?: string,
}


type Lista_Planificacion_Actualizar = {
    fechainicio: Date,
    fechafin: Date,
    estadoAprobacion?: string,
    idplanificacion: number,
    observacion?: string
}

export type Datos_Aprobar_Rechazar = {
    accion: string,
    idplanificacion: number
}

export const PRIMER_APROBADOR = "PA";
export const SEGUNDO_APROBADOR = "SA";
export const UNICO_APROBADOR = "UA";

const ESTADO_PENDIENTE = "P"
const ESTADO_APROBADO = "AP"
const ESTADO_RECHAZADO = "RE"


const ModalDirectivo: React.FC<Props_ModalDirectivo> = (props: Props_ModalDirectivo) => {

    const [cards_calendario, setcards_calendario] = useState<HTMLElement[]>([])
    const [nombre_persona, setnombre_persona] = useState<string>("");
    const [lista_planificacion_actualizar, setlista_planificacion_actualizar] = useState<Lista_Planificacion_Actualizar[]>([])
    const [datos_aprobar_rechazar, setdatos_aprobar_rechazar] = useState<Datos_Aprobar_Rechazar>({ accion: "", idplanificacion: -1 })
    const [lista_planificacion_para_calendario, setlista_planificacion_para_calendario] = useState<Planificacion_Vacaciones[]>([])
    const [loading, setloading] = useState<boolean>(false)
    const [enviar, setenviar] = useState<number>(-1);
    const [enviado, setenviado] = useState(false)
    const [problema, setproblema] = useState(false)
    //Verificar si es un segundo aprobadr
    const [segundoAprobador, setsegundoAprobador] = useState<boolean>(true)
    //Errores en llamadas
    const [listaErrores, setlistaErrores] = useState<string[]>([]);
    //Texto advertencia
    const [textoAdvertencia, settextoAdvertencia] = useState<string>("")
    //CondicionalesParaactualizar
    const [estadoPuedeEnviar, setestadoPuedeEnviar] = useState<boolean>(true)
    const [puedeenviar, setpuedeenviar] = useState<boolean>(false);
    //Input que se muestra 
    const [showinputobservacion, setshowInputObservacion] = useState<boolean>(false)
    const [textoObservacion, settextoObservacion] = useState<string>("")
    //Tipo de aprobador
    const [tipo_aprobador, settipo_aprobador] = useState<string>("")

    const modificar_planificacion_calendario = (idplanificacion: number, estado: string, todo: boolean = false) => {
        var copia_listado_planificacion_calendario: Array<Planificacion_Vacaciones> = [...lista_planificacion_para_calendario];
        var indice_planificacion = copia_listado_planificacion_calendario.findIndex((planificacion_vacaciones) => planificacion_vacaciones.idplanificacion == idplanificacion);
        if (indice_planificacion !== -1 && !todo) {
            copia_listado_planificacion_calendario[indice_planificacion].estado = estado
        }
        else if (todo) {
            copia_listado_planificacion_calendario.map((valores_copia) =>
                valores_copia.estado = estado
            )
        }
        return copia_listado_planificacion_calendario;
    }

    const auxiliar_aprobar = (idplanificacion: number) => {

        var planificacion_modificada = modificar_planificacion_calendario(idplanificacion, ESTADO_APROBADO);
        setlista_planificacion_para_calendario(planificacion_modificada);

    }
    const auxiliar_aprobar_todo = () => {
        var planificacion_modificada = modificar_planificacion_calendario(0, ESTADO_APROBADO, true);
        setlista_planificacion_para_calendario(planificacion_modificada);
    }
    const auxiliar_rechazar_todo = () => {
        var planificacion_modificada = modificar_planificacion_calendario(0, ESTADO_RECHAZADO, true);
        setlista_planificacion_para_calendario(planificacion_modificada);
    }
    const auxiliar_rechazar = (idplanificacion: number) => {
        var planificacion_modificada = modificar_planificacion_calendario(idplanificacion, ESTADO_RECHAZADO);
        setlista_planificacion_para_calendario(planificacion_modificada);
    }


    const auxiliar_cerrar_modal_encerar = () => {

        const cards_calendario_vacio: Array<HTMLElement> = [];
        setcards_calendario(cards_calendario_vacio);
        const nombre_persona_vacio = "";
        setnombre_persona(nombre_persona_vacio)
        const lista_planificacion_actualizar_vacio: Array<Lista_Planificacion_Actualizar> = [];
        setlista_planificacion_actualizar(lista_planificacion_actualizar_vacio)
        const datos_aprobar_rechazar_vacio: Datos_Aprobar_Rechazar = { accion: "", idplanificacion: -1 };
        const lista_planificacion_para_calendario_vacio: Array<Planificacion_Vacaciones> = [];
        setlista_planificacion_para_calendario(lista_planificacion_para_calendario_vacio)
        const loading_nuevo = false;
        const enviar_nuevo = -1;
        setenviar(enviar_nuevo)
        const enviado_nuevo = false;
        setenviado(enviado_nuevo)
        const problema_nuevo = false;
        setproblema(problema_nuevo)
        const listaErrores_vacio: Array<string> = []
        setlistaErrores(listaErrores_vacio)
        const puedeenviar_nuevo = false;
        setpuedeenviar(puedeenviar_nuevo)
        settextoObservacion("")
        props.toogle();
    }


    const generar_cards_calendario = (arreglo_calendario: Array<Calendario_Vacaciones_Modal>, tipo_aprobador: string) => {

        const generar_icon_segun_estado = (estado: string | undefined): JSX.Element => {
            if (estado) {
                var clase_icono = ""

                switch (estado) {
                    case ESTADO_APROBADO:
                        clase_icono = "far fa-check-circle icono_aprobado"
                        break;
                    case ESTADO_RECHAZADO:
                        clase_icono = "far fa-times-circle icono_rechazado"
                        break;
                    default:
                        break;
                }
                return <React.Fragment>
                    <i className={clase_icono}></i>

                </React.Fragment>;
            }

            return <div></div>

        }

        //DEPENDO DE ESTADOS
        const aprobar_planificacion = (idplanificacion: number) => {

            setdatos_aprobar_rechazar({ accion: "A", idplanificacion });

        }
        const rechazar_planificacion = (idplanificacion: number) => {
            setdatos_aprobar_rechazar({ accion: "R", idplanificacion });

        }



        const generar_acciones = (idplanificacion: number, estado: undefined | string, iddirectivounidad: number) => {
            var clase_aprobar = "far fa-check-circle "
            var clase_rechazar = "far fa-times-circle"
            var clase_parcial = "far fa-check-circle "
            var datos =  authenticationService.currentUserValue;

            if (estado != undefined) {
                var estado_unificado = estado.trim().toUpperCase();
                if (estado_unificado === ESTADO_APROBADO) {
                    clase_aprobar += " opcion_aprobar_planificacion";
                }
                else if (estado_unificado === ESTADO_RECHAZADO) {
                    clase_rechazar += " opcion_rechazar_planificacion";
                }
                else if (estado_unificado === ESTADO_APROBACION_PARCIAL) {
                    clase_parcial += " opcion_parcial";
                }

                if (estado === ESTADO_ENVIADO_TALENTO_HUMANO) {
                    return <i></i>
                }
                // if (iddirectivounidad !== datos.idpersona) {
                if (iddirectivounidad !== null && iddirectivounidad !== 0 && tipo_aprobador === PRIMER_APROBADOR) {

                    return (
                        <React.Fragment>
                            {
                                tipo_aprobador === PRIMER_APROBADOR && estado_unificado === ESTADO_APROBACION_PARCIAL ?
                                    <i className={clase_parcial} data-bs-toggle="tooltip" data-bs-placement="top" title="Aprobada Parcialmente" data-bs-custom-class="toogle_personalizado_aprobadopa" ></i>
                                    :
                                    <i className={clase_aprobar} data-bs-toggle="tooltip" data-bs-placement="top" title="Aprobada" data-bs-custom-class="toogle_personalizado_aprobado" ></i>

                            }
                            {   estado_unificado == ESTADO_RECHAZADO &&
                                <i className={clase_rechazar} data-bs-toggle="tooltip" data-bs-placement="top" title="Rechazada" ></i>
                            }



                        </React.Fragment>
                    );
                }                
                return (
                    <React.Fragment>
                        {
                            tipo_aprobador === PRIMER_APROBADOR && estado_unificado === ESTADO_APROBACION_PARCIAL ?
                                <i className={clase_parcial} data-bs-toggle="tooltip" data-bs-placement="top" title="Aprobar" data-bs-custom-class="toogle_personalizado_aprobar" ></i>
                                :
                                <i className={clase_aprobar} data-bs-toggle="tooltip" data-bs-placement="top" title="Aprobar" data-bs-custom-class="toogle_personalizado_aprobar" onClick={() => { aprobar_planificacion(idplanificacion) }}></i>

                        }
                        {
                            <i className={clase_rechazar} data-bs-toggle="tooltip" data-bs-placement="top" title="Rechazar" onClick={() => { rechazar_planificacion(idplanificacion) }}></i>
                        }



                    </React.Fragment>
                );
                
            }
        }



        const cards: any = arreglo_calendario.map((calendario, index_calendario) => {

            return (
                <Col className="mb-5" xl={6} key={calendario.Mes + index_calendario} >
                    <Card className="card_planificacion_vacaciones">

                        <CardTitle className="card_header_vacaciones"  >
                            <div className="circle_header" style={{ background: `${calendario.Color}` }} >
                                <div className="anio_number">{calendario.Anio}</div>
                            </div>
                            <div className="container_text_card_header_vacaciones">
                                <span>
                                    {calendario.Mes}
                                </span>
                            </div>
                        </CardTitle>
                        <CardBody>
                            <Table bordered className="table_planificacion_vacaciones" >
                                <thead className="cabeceras_tabla_planificacion_vac">
                                    <tr className="borde_cabeceras_planificacion">
                                        <th>Desde</th>
                                        <th>Hasta</th>
                                        <th>Días</th>
                                        <th>Acciones</th>
                                    </tr>

                                </thead>
                                <tbody>
                                    {calendario.Rows?.map((fila, index_row) => {
                                        // var finicial = formatoISO ? new Date(fila.Fechadesde).toISOString() : fila.Fechadesde.toString()
                                        // var ffinal = formatoISO ? new Date(fila.Fechahasta).toISOString() : fila.Fechahasta.toString()
                                        var finicial = new Date(fila.fechainicio).toISOString()
                                        var ffinal = new Date(fila.fechafin).toISOString()

                                        return (
                                            <tr key={"row" + calendario.Mes + index_row} className="rows_tabla_planificacion_vac">
                                                <td> {formatoFecha(finicial)}</td>
                                                <td>{formatoFecha(ffinal)}</td>
                                                <td>{fila.dias_solicitados}</td>
                                                {/* <td>{fila.estado}</td> */}
                                                <td className="columna_acciones_directivo_card">{generar_acciones(fila.idplanificacion, fila.estado, fila.iddirectivounidad)}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>

                            </Table>
                        </CardBody>


                    </Card>
                </Col>
            )


        })
        return cards;
    }

    const generar_arreglo_calendario = (arreglo_planificacion: Array<Planificacion_Vacaciones>) => {
        var arreglo_calendario: Array<Calendario_Vacaciones_Modal> = []



        arreglo_planificacion.map((valores_planificacion, index_planificacion) => {

            var fecha_inicio_ISO = new Date(valores_planificacion.fechainicio).toISOString();
            const anioMostrar = valores_planificacion.fechainicio.toString().split("-")[0];
            var indice_mes: number = +formatoFecha(fecha_inicio_ISO).split("/")[1] - 1;
            const [mes, color_mes] = function_parse_calendario(indice_mes, false);

            var indice_busco_calendario = arreglo_calendario.findIndex((calendario_individual) => calendario_individual.Mes === mes);

            if (indice_busco_calendario === -1) {
                arreglo_calendario.push(
                    {
                        Anio: anioMostrar,
                        Mes: mes,
                        Color: color_mes,
                        Orden: indice_mes + 1,
                        Rows: [valores_planificacion],
                        Persona_Regula: valores_planificacion.directivounidad,
                        Estado: valores_planificacion.estado

                    }
                )
            }

            else {
                arreglo_calendario[indice_busco_calendario].Rows?.push(valores_planificacion);
            }
        })
        return arreglo_calendario;

    }





    useEffect(() => {

        const obtener_datos_persona = async () => {

            setloading(true)
            const currentUser = authenticationService.currentUserValue;

            const respuesta = await axios.get(configData.SERVER_URL + `PlanificacionVacaciones/Directivo/DatosPersona/${props.idpersona}`,
                {
                    headers: {
                        Authorization: `KEYESPOL ${currentUser?.token}`
                    }


                });

            var datos_respuesta: Respuesta_Planificacion_Usuario = respuesta.data;

            var contador_aprobados_parcialmente = 0;
            datos_respuesta.listado_planificacion.map((valores_listado) => {
                if (valores_listado.estado === ESTADO_RECHAZADO && valores_listado.observacion)
                    settextoObservacion(valores_listado.observacion)
                if (valores_listado.estado === ESTADO_APROBACION_PARCIAL) { contador_aprobados_parcialmente++ }
            })

            if (contador_aprobados_parcialmente === 0) setsegundoAprobador(false)

            // if(props.estado_persona_planificaciones)

            setlista_planificacion_para_calendario(datos_respuesta.listado_planificacion);
            setnombre_persona(datos_respuesta.nombre_persona);
            setloading(false)
        }


        if (props.idpersona != -1 && props.estado_persona_planificaciones !== "") {
            obtener_datos_persona();
        }

    }, [props.idpersona, props.estado_persona_planificaciones])

    useEffect(() => {
        if (props.tipo_aprobador !== "") {
            settipo_aprobador(props.tipo_aprobador);
        }
    }, [props.tipo_aprobador])

    useEffect(() => {





        if (lista_planificacion_actualizar.length !== 0) {
            var arreglo_calendario: Array<Calendario_Vacaciones_Modal> = generar_arreglo_calendario(lista_planificacion_para_calendario);
            setcards_calendario(generar_cards_calendario(arreglo_calendario, tipo_aprobador));
        }
    }, [lista_planificacion_actualizar])

    useEffect(() => {
        var arreglo_planificacion_actualizar: Array<Lista_Planificacion_Actualizar> = []
        var cantidad_elementos_pendientes = 0;
        var cantidad_elementos_no_pendientes = 0;
        var cantidad_elementos_aprobados_parcialmente = 0;

        var hay_planificacion_rechazada = false;

        lista_planificacion_para_calendario.map((valores_planificacion, index_lista_planificaciones) => {

            if (valores_planificacion.estado === ESTADO_PENDIENTE) {
                cantidad_elementos_pendientes++;
            }
            if (valores_planificacion.estado === ESTADO_RECHAZADO) {
                hay_planificacion_rechazada = true
                cantidad_elementos_no_pendientes++;
            }
            if (valores_planificacion.estado === ESTADO_APROBADO) {
                cantidad_elementos_no_pendientes++
            }
            else if (valores_planificacion.estado === ESTADO_APROBACION_PARCIAL) {
                cantidad_elementos_aprobados_parcialmente++;
                cantidad_elementos_no_pendientes++;

            }

            arreglo_planificacion_actualizar.push({
                fechainicio: valores_planificacion.fechainicio,
                fechafin: valores_planificacion.fechafin,
                estadoAprobacion: valores_planificacion.estado,
                idplanificacion: valores_planificacion.idplanificacion,
            })
        })

        if (hay_planificacion_rechazada) setshowInputObservacion(true)
        else setshowInputObservacion(false)


        //DETERMINAR SI LE APARECE EL BOTON DE ENVIAR 


        //PRIMER APROBADOR
        if (props.tipo_aprobador == PRIMER_APROBADOR) {
            if (lista_planificacion_para_calendario.length) {
                setpuedeenviar(true)
            }

        }
        //SEGUNDO APROBADOR
        if (props.tipo_aprobador == SEGUNDO_APROBADOR) {
            if (lista_planificacion_para_calendario.length > 0 && cantidad_elementos_aprobados_parcialmente == 0) {
                setpuedeenviar(true)
            }
        }
        //UNICO APROBADOR

        if (props.tipo_aprobador == UNICO_APROBADOR) {
            if (lista_planificacion_para_calendario.length > 0) {
                setpuedeenviar(true)
            }
        }

        setlista_planificacion_actualizar(arreglo_planificacion_actualizar);

    }, [lista_planificacion_para_calendario])

    useEffect(() => {
        const { accion, idplanificacion } = datos_aprobar_rechazar;
        if (accion === "A" && idplanificacion !== -1) {
            auxiliar_aprobar(idplanificacion);
        }
        else if (accion === "R" && idplanificacion !== -1) {
            auxiliar_rechazar(idplanificacion);
        }


    }, [datos_aprobar_rechazar.accion, datos_aprobar_rechazar.idplanificacion])

    useEffect(() => {
        const handleenviaraprobacionrechazo = async () => {
            setloading(true);
            const currentUser = authenticationService.currentUserValue;
            //Observacion si esta rechazado
            var copia_listado_actualizar: Array<Lista_Planificacion_Actualizar> = [];
            lista_planificacion_actualizar.map((planif_actualizar) => {

                var copia_planif_actual: Lista_Planificacion_Actualizar = planif_actualizar;
                if (copia_planif_actual.estadoAprobacion === ESTADO_RECHAZADO) {
                    copia_planif_actual.observacion = textoObservacion
                    copia_listado_actualizar.push(copia_planif_actual);
                }
                else if (copia_planif_actual.estadoAprobacion === ESTADO_APROBADO) {
                    copia_listado_actualizar.push(copia_planif_actual);

                }

            })

            if (showinputobservacion && textoObservacion === "") {
                settextoAdvertencia("Debe colocar un motivo de rechazo");
            }
            else {
                try {
                    const respuesta_aprobacionrechazo = await axios.post(configData.SERVER_URL + `PlanificacionVacaciones/Directivo/AprobarRechazar/${props.idpersona}`,
                        copia_listado_actualizar,
                        {
                            headers: {
                                Authorization: `KEYESPOL ${currentUser?.token}`
                            }


                        });

                    if (respuesta_aprobacionrechazo.data) {
                        settipo_aprobador(respuesta_aprobacionrechazo.data)
                    }
                    setenviado(true)
                    setloading(false);
                    window.location.reload();

                } catch (error) {
                    var error_any: any = error;
                    var status = handle_error(error_any);

                    switch (status) {
                        case 400:
                            var respuesta = error_any.response;
                            if (respuesta.data.errors) {
                                var problemas: Array<string> = respuesta.data.errors["Actualizar_Planificacion"];
                                setlistaErrores(problemas);
                            }
                            break;
                        case 401:
                            var problemas: Array<string> = ["No tiene permisos para realizar esta acción"];
                            setlistaErrores(problemas);
                        default:
                            break;
                    }


                    setproblema(true)
                }

            }


            setloading(false);

        }


        if (enviar > -1) {
            handleenviaraprobacionrechazo();
        }
    }, [enviar])

    useEffect(() => {

        if (enviado && tipo_aprobador !== "") {
            var datos_propagar: Datos_Planificacion_Aprobada = { datos_planificacion: lista_planificacion_para_calendario, persona: nombre_persona, idpersona: props.idpersona, tipo_aprobador }
            props.propagar_Aprobado(datos_propagar);
        }
        // var array_planificacion_aprobada: Array<Planificacion_Vacaciones> = []
        // lista_planificacion_para_calendario.map((planif) => {
        //     if (planif.estado && planif.estado === ESTADO_APROBADO) array_planificacion_aprobada.push(planif);
        // })
        //  if (array_planificacion_aprobada.length > 0) { props.propagar_Aprobado(array_planificacion_aprobada, nombre_persona, props.idpersona) }



    }, [enviado, tipo_aprobador])

    useEffect(() => {
        if (textoAdvertencia !== "") {
            setpuedeenviar(false)
        }
    }, [textoAdvertencia])

    useEffect(() => {
        if (textoObservacion !== "") {
            var cantidad_elementos_pendientes = 0;
            lista_planificacion_para_calendario.map((valores_planificacion, index_lista_planificaciones) => {

                if (valores_planificacion.estado === ESTADO_PENDIENTE) {
                    cantidad_elementos_pendientes++;
                }
            });

            if (lista_planificacion_para_calendario.length !== 0 && cantidad_elementos_pendientes === 0) {
                setpuedeenviar(true)
            }
        }

    }, [textoObservacion])

    const handlevalorenviar = (valor: number) => {
        return valor + 1;
    }


    return (
        <Modal
            isOpen={props.show}
            scrollable={true}
            size={"xl "}
            fullscreen={"xl"}
            centered={true}
            onClosed={props.onClose}
        >
            <ModalHeader close={<button onClick={() => auxiliar_cerrar_modal_encerar()} >x</button>} />
            <ModalBody>
                <p className="titulo_planificacion_vacaciones">PLANIFICACIÓN DE VACACIONES</p>
                {/* {!puedeenviar && <small className={"advertencia_enviar"}> Debe aprobar o rechazar todas las planificaciones antes de poder enviarlas</small>} */}
                {cards_calendario.length !== 0 && !loading && !enviado && !problema &&

                    <Container fluid>
                        <Row className="align-items-center">
                            <Col lg={6} xs={12}>
                                <p className="mb-2 nombre_persona_planifica_directivo">  {nombre_persona !== "" && nombre_persona} </p>

                            </Col>
                            {/* <Col lg={3} xs={12} className="text-sm-center mb-sm-2">
                                {
                                     props.mostrar_boton_enviar &&!enviado && !loading && lista_planificacion_para_calendario.length != 0 &&
                                    <div className="container_botones">
                                        <button className={"btnAprobarTodo"} onClick={() => auxiliar_aprobar_todo()}>Marcar todos como aprobados</button>

                                    </div>
                                }
                            </Col>
                            <Col lg={3} xs={12} className="text-sm-center mb-sm-2">
                                {
                                     props.mostrar_boton_enviar &&!enviado && !loading && lista_planificacion_para_calendario.length != 0 &&
                                    <div className="container_botones">
                                        <button className={"btnRechazarPlanificacion"} onClick={() => auxiliar_rechazar_todo()}>Marcar todos como rechazados</button>

                                    </div>
                                }
                            </Col> */}
                        </Row>
                        <Row >
                            {cards_calendario}

                        </Row>
                        <Row>
                            <Col xl={4}>
                                {
                                    textoAdvertencia && <div className="advertencia_observacion"> {textoAdvertencia} </div>
                                }
                            </Col>
                        </Row>
                        <Row>
                            {showinputobservacion &&
                                <React.Fragment>

                                    <Col xl={4}>
                                        <div className="observaciones_rechazo">Observaciones Rechazo</div>
                                    </Col>
                                    <Col xl={12}>

                                        <textarea
                                            className="textareaObservacion"
                                            rows={2}
                                            cols={20}
                                            maxLength={255}
                                            value={textoObservacion}
                                            onChange={(e) => settextoObservacion(e.target.value)}
                                        />
                                    </Col>
                                </React.Fragment>
                            }



                        </Row>
                    </Container>

                }
                {
                    loading && <Cargando />
                }
                {
                    enviado && !loading && !problema &&
                    <div>
                        <div className="text-center">Se han confirmado sus acciones, espere un momento por favor...</div>
                        {/* <div className="container_botones">
                            <button className="btnAprobarPlanificacion" onClick={() => window.location.reload()}> Continuar</button>
                        </div> */}
                    </div>
                }
                {
                    problema && !loading &&
                    <div className="text-center">
                        <div className="cabecera_mensajes_errores">
                            Ha ocurrido un inconveniente al tratar de actualizar las planificaciones
                        </div>
                        <div className="text-center">
                            {
                                listaErrores.length != 0 &&
                                listaErrores.map((error, index) => {
                                    return (
                                        <div key={`error ${index}`} className="errores_actualizacion_planificacion" >
                                            {error}
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>

                }


            </ModalBody>
            <ModalFooter>
                <Container>
                    <Row className="justify-content-end">
                        {


                            props.mostrar_boton_enviar && !props.isDelegado && !enviado && !loading && lista_planificacion_para_calendario.length != 0 &&
                            <Col xl={3} lg={3} md={3} xs={6} className="text-sm-center text-center mb-sm-2  mb-xs-2" >
                                <div className="container_botones  mb-sm-2  mb-2">
                                    <button className={"btnAprobarTodo mb-sm-2  mb-xs-2"} onClick={() => auxiliar_aprobar_todo()}>Marcar todos como aprobados</button>

                                </div>
                            </Col>
                        }


                        {
                            props.mostrar_boton_enviar && !props.isDelegado && !enviado && !loading && lista_planificacion_para_calendario.length != 0 &&
                            <Col xl={3} lg={3} md={3} xs={6} className="text-sm-center text-center mb-sm-2 mb-2">
                                <div className="container_botones  mb-sm-2  mb-xs-2" >
                                    <button className={"btnRechazarPlanificacion mb-sm-2  mb-xs-2"} onClick={() => auxiliar_rechazar_todo()}>Marcar todos como rechazados</button>

                                </div>
                            </Col>

                        }








                        {
                            props.mostrar_boton_enviar && !props.isDelegado && puedeenviar && !enviado && !loading &&
                            <Col xl={1} lg={3} md={3} xs={6} className="text-sm-center text-center mb-sm-2 ">
                                <div className="container_botones">
                                    <button className="btnAprobarPlanificacion" onClick={() => setenviar(handlevalorenviar(enviar))}>Confirmar</button>
                                </div>

                            </Col>
                        }
                        {
                            !enviado && !loading &&
                            <Col xl={1} lg={3} md={3} xs={6} className=" mb-sm-2 text-sm-center text-center mb-sm-2 ">
                                <div className="container_botones">
                                    <button className="btnRechazarPlanificacion" onClick={() => auxiliar_cerrar_modal_encerar()}>Cancelar</button>
                                </div>

                            </Col>

                        }


                    </Row>
                </Container>


            </ModalFooter>
        </Modal>
    )
}
export default ModalDirectivo;


